import { FilterOperator, FilterValueType, getDefaultOperatorsForValueType, getOperatorLabel, getOperatorsForFilterType, getOperatorsList } from "../../constants/FilterConstants.js";
import { templateParseToElement } from "../../logic/templateParse.js";
import { ColumnDataFilterSubset } from "../../types/ListManagerTypes.js";
import { BaseWebComponent } from "../base-components/base-web-component.js";
interface FilterOperatorsComponentData {
    list: Partial<Record<FilterOperator, string>>;
    filterValueType?: FilterValueType;
    defaultFilterOperator?: FilterOperator;
    defaultLabel?: string;
}

export class FilterOperatorsComponent extends BaseWebComponent {
    static webComponentName: string = "filter-operators";
    protected _templateId: string = "filter-operators-template";
    private _componentData: Partial<FilterOperatorsComponentData> = {};
    private _colData!: ColumnDataFilterSubset;
    private  _value: FilterOperator | undefined;
    // =============================
    // Supported operators for filters
    // =============================
    constructor() {
        super();
    }

    protected get filterValueType(): FilterValueType {
        return this.colData.filterValueType || 'string';
    }
    get value(): FilterOperator | undefined {
        
        return this._value;
    }
    private set value(val: FilterOperator | undefined) {
        this._value = val;
        if (this._value!=undefined ) {
           this.dispatch('change',{value: this._value});
           this.refreshDropdown();
        }
        else {
            console.log(`FilterOperatorsComponent: value is undefined, not dispatching change event`);
        }
    }
    private refreshDropdown(target?: HTMLElement): void {
        const btnDropdown = this.roleElementSelector('filter-operators-dropdown');
        if (btnDropdown && this.value) {
            const filterOperatorsLabel = btnDropdown.querySelector('[role="filter-operators-label"]');
            if (filterOperatorsLabel) {
                filterOperatorsLabel.textContent = getOperatorLabel(this.value);
            }
            else {
                btnDropdown.textContent = getOperatorLabel(this.value);

            }
            this.querySelectorAll(`[role="filter-operator"]`).forEach(el => {
                const icoEl = el.querySelector('i');
                const value = (el as HTMLElement).dataset.value;
                if (value != this.value) {
                    icoEl?.classList.remove('bi-check-circle');
                    icoEl?.classList.remove('text-success');
                    icoEl?.classList.add('bi-circle');
                }
                else {
                    icoEl?.classList.add('bi-check-circle');
                    icoEl?.classList.add('text-success');
                    icoEl?.classList.remove('bi-circle');
                    
                }
            });
        }
    }
    protected onConnected(): void {
        this.on('click', `[role="filter-operator"]`, (e: Event) => {
            const target = e.target as HTMLElement;
            if (target && target.dataset.value) {
                this.value = target.dataset.value as FilterOperator;
                this.refreshDropdown(target);
            }
            else {
                console.warn('FilterOperatorsComponent: No value found in clicked element', target);
            }
        });
        // Default implementation does nothing
    }
    protected get defaultFilterOperator(): FilterOperator {        
        if (!this.colData.defaultFilterOperator) {
            return getDefaultOperatorsForValueType(this.filterValueType)[0] as FilterOperator;
        }
        let result = this.colData.defaultFilterOperator as FilterOperator;
        if(this.operators && this.operators.length > 0 && !this.operators.includes(result)) {
            console.log(`FilterOperatorsComponent: default operator ${result} not found in available operators, using first available operator`);
            result = this.operators[0] as FilterOperator; // Fallback to first available operator
        }
        return result;
    }
    protected get operators(): string[] {
        const colData = this.colData;
        const filterType = colData.filterType || "simple";
        const defaultOperatorsForType = getOperatorsForFilterType(filterType);
        const defaultOperatorsForValueType = getDefaultOperatorsForValueType(colData.filterValueType || 'string');
        const defaultOperators = defaultOperatorsForValueType.filter(op => defaultOperatorsForType.includes(op));
        if (typeof colData.filterOperators === 'undefined') {
            return defaultOperators || [];
        }
        return colData.filterOperators.filter(op => defaultOperators.includes(op));
    }
    get colData(): ColumnDataFilterSubset {
        return this._colData;
    }

    set colData(cdata: ColumnDataFilterSubset) {
        this._colData = cdata;
        let defaultFilterOperator = this.defaultFilterOperator;
        if(this.operators && this.operators.length > 0 && !this.operators.includes(defaultFilterOperator)) {
            defaultFilterOperator = this.operators[0] as FilterOperator; // Fallback to first available operator
        }
        this._componentData = {
            list: getOperatorsList(this.operators),
            filterValueType: this.filterValueType,
            defaultFilterOperator,
            defaultLabel: getOperatorLabel(defaultFilterOperator)
        };
        if (!this._value) {
            this.value = this.defaultFilterOperator;
        }
        if(this.operators.length === 1) this.value = this.operators[0] as FilterOperator;
        if(this.operators && this.operators.length > 0 && !this.operators.includes(this.value||'')) {
            this.value = this.operators[0] as FilterOperator; // Fallback to first available operator
        }
        
        this.render();
    }

    render(): void {
        if (!this._componentData || Object.keys(this._componentData).length === 0) {
            return; // nothing to render
        }
        this.innerHTML = ""; // Clear previous content
        // this.value = undefined; // Reset value to ensure it is set correctly
        templateParseToElement(this.templateId, this, {
            label:this._colData.label,
            name : this._colData.name,
            operatorsCount : this.operators.length,
            ...this._componentData,
            tooltip:this.attributeBoolOption("tooltip")
        });
    }
}